import React, {Component} from 'react';
import {connect} from 'react-redux';
import {confirmAlert} from "react-confirm-alert";

import {
    addFile,
    addValue,
    copyValue,
    getForms,
    getHistory,
    loadFrom,
    incrimentToSend,
    markAllVisited,
    markVisited,
    checkedPanel,
    recal,
    setError,
    setSection,
} from '../actions';

import {createApiClient} from '../services/ApiClient';
import {ActionsDefaultState, ActionsRules} from '../const/action_rules';
import * as FieldsRules from '../const/field_rules';
import * as FormRules from '../const/forms';

import RequestWithoutStore from '../modules/metajson-sub';
import Actions from './controls/Actions';

function multipleNotify(message) {
    confirmAlert({
        message: Array.isArray(message) && message.length > 0
            ?
            (typeof message[0] === 'object' ? message[0].message : message[0])
            :
            (typeof message === 'object' ? message.message : message),
        buttons: [
            {
                label: 'Ок',
                onClick: () => {}
            }
        ]
    });
}

class RequestForm extends Component {
    componentDidMount() {
        const { params: { form_type, process_id }} = this.props;
        this.api = createApiClient(form_type, process_id);
    }

    render = () => (
        <RequestWithoutStore
            notify={multipleNotify}
            api={this.api}
            extRules={{
                ActionsDefaultState,
                ActionsRules,
                ...FieldsRules,
                ...FormRules,
            }}
            extActions={Actions}
            {...this.props}
        />
    )
}

const mapStateToProps = (state) => ({
    schema: state.forms,
    loaders: state.forms.loaders,
    sections: state.forms.form.sections,
})

const mapDispatchToProps = (dispatch) => ({
    setSection: (id) => dispatch(setSection(id)),
    addValue: (id, value, refresh) => dispatch(addValue(id, value, refresh)),
    addFile: (id, filename) => dispatch(addFile(id, filename)),
    checkedPanel: (panelId, checked, error) => dispatch(checkedPanel(panelId, checked, error)),
    incrimentToSend: () => dispatch(incrimentToSend()),
    loadFrom: (form_type, process_id) => dispatch(loadFrom(form_type, process_id)),
    copyValue: (sourceId, targetId) => dispatch(copyValue(sourceId, targetId)),
    recal: () => dispatch(recal()),
    markVisited: (id) => dispatch(markVisited(id)),
    setError: (id, error) => dispatch(setError(id, error)),
    markAllVisited: () => dispatch(markAllVisited()),
    getForms: (page, pagesize) => dispatch(getForms(page, pagesize)),
    getHistory: (id) => dispatch(getHistory(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestForm);
